





















































































import { functions,auth, authObject} from "@/scripts/firebase";
import { NoticeProps } from "@/scripts/datatypes"
import { ValidationObserver } from 'vee-validate'
import Notice from "@/components/Notice.vue"
import { Component,Mixins } from "vue-property-decorator";
import Common from '@/mixins/common';

@Component({
  components: {
    Notice,
  }
})

export default class SignUp extends Mixins(Common) {
  isLoading = false
  email = '';
  password = '';
  displayName = '';
  schoolName = ''
  recaptchaVerified = false
  notice = {} as NoticeProps
  
  get observer(){
    return this.$refs.signUpValidationObserver as InstanceType<typeof ValidationObserver>;
  }

  get isDisabled(){
    return (this.email && this.password && this.displayName && this.schoolName && this.recaptchaVerified) ? false : true
  }

  async created(){
    console.trace('created');
    auth.signOut();
  }
 
 async mounted(){
  console.trace('mounted');

  const recaptchaVerifier = new authObject.RecaptchaVerifier(
      "recaptcha-container",{
        theme: 'light',// UIの色
        size: 'normal',// UIの大きさ
        tabindex: 0, // タブインデックス
        // ユーザーが正常な応答を送信したときに実行される
        callback: () => {
          this.recaptchaVerified = true
          this.observer.setErrors({
            reCAPTCHA: ''
          })
        },
        //reCAPTCHA応答が期限切れになり、ユーザーが再検証する必要があるときに実行される
        //Response expired. Ask user to solve reCAPTCHA again.
        "expired-callback": () => {
          this.observer.setErrors({
            reCAPTCHA: this.$t('authentication.reCAPTCHA.expired') as string
          })
          this.recaptchaVerified = false
        },
        // reCAPTCHAでエラー（通常はネットワーク接続）が発生し、接続が復元されるまで続行できない場合に実行される
        "error-callback": () => {
          this.observer.setErrors({
            reCAPTCHA: this.$t('authentication.reCAPTCHA.error') as string
          })
          this.recaptchaVerified = false
        }
      }
    );
    //const recaptchaWidgetId = await recaptchaVerifier.render();

    if(process.env.NODE_ENV === 'development'){
      this.recaptchaVerified = true
    }else{
      await recaptchaVerifier.render();
    }
 }

  destroyed() {
    console.trace('destroyed');
  }

  public async signUp() {
    try{
      this.notice = {
        isShow: false,
      }

      if(! await this.observer.validate() || ! this.recaptchaVerified){
        if(! this.recaptchaVerified){
          this.observer.setErrors({
            reCAPTCHA: this.$t('authentication.reCAPTCHA.required') as string
          })
        }
        return
      }

      this.$store.commit("setLoading",true);
      this.isLoading = true
   
      const createMaritoAccount = functions.httpsCallable('createMaritoAccount');

      const data = {
        email: this.email,
        password: this.password,
        displayName: this.displayName,
        schoolName: this.schoolName,
        lang: this.$store.getters.lang
      }

      await createMaritoAccount(data)

      await auth.signInWithEmailAndPassword(this.email, this.password);
        
      if(auth.currentUser){
        await auth.currentUser.sendEmailVerification()
        this.notice = {
          message: this.$t('signUp.emailVerification') as string,
          duration: 0,
          isShow: true,
          type: {'is-info': true}
        }
        await auth.signOut()
        console.log('Logout');
        this.email = '';
        this.password = '';
        this.displayName = ''
        this.schoolName = ''
        this.observer.reset()
      }
    }catch(error){
      console.table(error)
      const errorCode = this.$getErrorCode(error)
      const errorMessage0 = this.$t('signUp.error') as string

      const errorMessage1 = this.$getErrorMessage(errorCode)

      const errorField = this.$getErrorField(errorCode)

      if(errorMessage1 && errorField){        
        this.observer.setErrors({
         [errorField]: errorMessage1
        })
      }

      const errorMessage = (errorMessage1 === '') ? errorMessage0 : errorMessage0 + '<br />' + errorMessage1
      this.notice = {
        message: errorMessage,
        isShow: true,
        type: {'is-danger': true}
			}
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
    }
  }
}
